if (!customElements.get('hotspots-image')) {
    class HotspotsImage extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.handleClick.bind(this));
      }
  
      connectedCallback() {
        this.setInitialCardPositions();
      }
  
      disconnectedCallback() {
        window.removeEventListener('on:debounced-resize', this.resizeHandler);
      }
  
      setInitialCardPositions() {
        const imageCenterX = this.getBoundingClientRect().width / 2;
        this.querySelectorAll('.hotspot').forEach(hotspot => {
          const rect = hotspot.getBoundingClientRect();
          hotspot.classList.toggle('hotspot--on-left', rect.left + rect.width / 2 > imageCenterX);
          hotspot.classList.toggle('hotspot--on-right', rect.left + rect.width / 2 <= imageCenterX);
        });
      }
  
      handleClick(evt) {
        const btn = evt.target.closest('.hotspot__btn');
        if (!btn) return;
        const hotspot = btn.parentNode;
        hotspot === this.activeHotspot ? this.closeActiveHotspot(evt) : (this.activeHotspot && this.closeActiveHotspot(evt), this.activateHotspot(hotspot));
      }
  
      handleClickOutside(evt) {
        if (!evt.target.closest('.hotspot__btn, .hotspot__product') && this.activeHotspot) {
          this.closeActiveHotspot(evt);
        }
      }
  
      handleKeyup(evt) {
        if (evt.key === 'Escape' && this.activeHotspot) this.closeActiveHotspot(evt);
      }
  
      handleTransitionEnd(evt) {
        if (this.activeHotspot || evt.propertyName !== 'opacity') return;
        this.classList.add('overflow-hidden');
        this.activeCard.style = null;
        this.activeCard = null;
        this.removeEventListener('transitionend', this.transitionHandler);
      }
  
      isMobile() {
        return window.matchMedia('(max-width: 991px)').matches;
      }

      activateHotspot(hotspot) {
        this.activeCard = hotspot.querySelector('.hotspot__card');
        if (!this.activeCard) return;
        this.checkCardPosition();
        this.classList.remove('overflow-hidden');
        this.setHotspotActiveState(hotspot, true);
        if (this.isMobile()) {
          this.overlayShownByHotspot = SiteOverlay?.showOverlay?.() ?? false;
        }
        window.trapFocus?.(hotspot);
        this.clickOutsideHandler ||= this.handleClickOutside.bind(this);
        this.keyUpHandler ||= this.handleKeyup.bind(this);
        this.resizeHandler ||= this.closeActiveHotspot.bind(this);
        document.addEventListener('click', this.clickOutsideHandler);
        document.addEventListener('keyup', this.keyUpHandler);
        window.addEventListener('on:debounced-resize', this.resizeHandler);
      }
  
      closeActiveHotspot(evt) {
        evt.preventDefault();
        if (evt.type !== 'on:debounced-resize') {
          this.transitionHandler ||= this.handleTransitionEnd.bind(this);
          this.addEventListener('transitionend', this.transitionHandler);
        }
        if (!this.activeHotspot) return;
        if (this.overlayShownByHotspot) {
          // SiteOverlay?.hideOverlay?.();
          this.overlayShownByHotspot = false;
        }
        this.setHotspotActiveState(this.activeHotspot, false);
        window.removeTrapFocus?.();
        if (evt.type === 'on:debounced-resize') {
          this.classList.add('overflow-hidden');
          this.activeCard.style = null;
          this.activeCard = null;
        }
        document.removeEventListener('click', this.clickOutsideHandler);
        document.removeEventListener('keyup', this.keyUpHandler);
        if (this.isMobile()) {
          document.getElementById('site-overlay')?.click();
        }
      }
  
      checkCardPosition() {
        if (!this.activeCard) return;
        const isDesktop = window.theme?.mediaMatches?.md || window.matchMedia('(min-width: 992px)').matches;
        const hotspot = this.activeCard.parentElement;
        let cardRect;
        
        if (isDesktop) {
          const rect = hotspot.getBoundingClientRect();
          const imageCenterX = this.getBoundingClientRect().width / 2;
          hotspot.classList.toggle('hotspot--on-left', rect.left + rect.width / 2 > imageCenterX);
          hotspot.classList.toggle('hotspot--on-right', rect.left + rect.width / 2 <= imageCenterX);
          cardRect = this.activeCard.getBoundingClientRect();
        }
        //  else {
        //   const buttonRect = hotspot.getBoundingClientRect();
        //   const imageWidth = this.getBoundingClientRect().width;
        //   const offset = this.activeCard.clientWidth / 2;
        //   this.activeCard.style.right = `calc(50% - ${offset}px)`;
        //   cardRect = this.activeCard.getBoundingClientRect();
        //   const left = buttonRect.left + buttonRect.width / 2 - cardRect.width / 2;
          
        //   if (left < 10) {
        //     this.activeCard.style.right = `calc(50% - ${offset - left}px - var(--gutter))`;
        //   } else {
        //     const right = buttonRect.left + buttonRect.width / 2 + cardRect.width / 2;
        //     if (right > imageWidth - 10) {
        //       this.activeCard.style.right = `calc(50% - ${offset - (right - imageWidth)}px + var(--gutter))`;
        //     }
        //   }
        // }
        
        if (cardRect?.bottom > document.documentElement.clientHeight) {
          this.activeCard.style.top = 'auto';
          this.activeCard.style.bottom = 'calc(100% + 12px)';
        }
      }
  
      setHotspotActiveState(hotspot, active) {
        hotspot.classList.toggle('is-active', active);
        hotspot.querySelector('.hotspot__btn')?.setAttribute('aria-expanded', active);
        hotspot.querySelector('.hotspot__card')?.setAttribute('aria-hidden', !active);
        this.activeHotspot = active ? hotspot : null;
      }
    }
  
    customElements.define('hotspots-image', HotspotsImage);
  }